import { HOURS_PER_DAY, TIME_FORMAT } from "constant/date";
import dayjs from "dayjs";
import { shiftOptions } from "page/Customer/CustomerDetail/CarePlan/constants";
import { useMemo } from "react";
import { PatientSchedule } from "types/admin";

interface usePatientSchedulesProps {
  patientSchedules: PatientSchedule[];
}

const HAFT_OF_HOUR = 30;
const NUM_OF_SECTIONS = 48;
const SEPERATOR = ":";

const usePatientSchedules = ({
  patientSchedules,
}: usePatientSchedulesProps) => {
  const scheduleTimes = useMemo(() => {
    const startTime = dayjs().startOf("day");

    const scheduleTimes = Array.from({ length: NUM_OF_SECTIONS }).map(
      (_, index) => {
        return dayjs(startTime)
          .add(index * HAFT_OF_HOUR, "minutes")
          .format(TIME_FORMAT);
      }
    );
    return scheduleTimes;
  }, []);

  const mappingPatientSchedules = (patientSchedules: PatientSchedule[]) => {
    const patientSchedulesSort = shiftOptions.map((op) => {
      return patientSchedules?.find((x) => x.shift_type === op.value);
    }).filter(Boolean);
    const listSchedules = patientSchedulesSort?.map((patientSchedule) => {
      return patientSchedule?.schedules?.map((item) => {
        const [startTimeHours, startTimeMinutes] =
          item.start_time_format?.split(SEPERATOR);
        const [endTimeHours, endTimeMinutes] =
          item.end_time_format?.split(SEPERATOR);

        let startTime = dayjs()
          .set("hours", parseInt(startTimeHours))
          .set("minutes", parseInt(startTimeMinutes))
          .set("milliseconds", 0);

        let endTime = dayjs()
          .set(
            "hours",
            parseInt(endTimeHours) === HOURS_PER_DAY
              ? 0
              : parseInt(endTimeHours)
          )
          .set("minutes", parseInt(endTimeMinutes))
          .set("milliseconds", 0);

        if (endTime.get("hour") === 0 && endTime.get("minute") === 0) {
          endTime = endTime.set("hour", 23).set("minute", 59).set("second", 59);
        }

        const rootTime = dayjs().startOf("day");

        const offset =
          dayjs(startTime).diff(rootTime, "minutes") / HAFT_OF_HOUR;

        const numOfSections = Math.round(
          dayjs(endTime).diff(startTime, "minutes") / HAFT_OF_HOUR
        );

        return { ...item, offset, numOfSections };
      });
    });

    return listSchedules;
  };

  const newPatientSchedules = useMemo(() => {
    return mappingPatientSchedules(patientSchedules);
  }, [patientSchedules]);

  return { patientSchedules: newPatientSchedules, scheduleTimes };
};

export default usePatientSchedules;
